
import { supabase } from '@/integrations/supabase/client';

/**
 * Fetch projects the user is collaborating on
 * @returns Array of projects with role information
 */
export const fetchCollaborativeProjects = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return [];
    
    const { data: collaborations, error: collaborationsError } = await supabase
      .from('project_collaborators')
      .select('project_id, role')
      .eq('user_id', user.id);
    
    if (collaborationsError) throw collaborationsError;
    
    const projects = [];
    
    for (const collab of collaborations || []) {
      const { data: project, error: projectError } = await supabase
        .from('projects')
        .select('*')
        .eq('id', collab.project_id)
        .single();
      
      if (projectError) {
        console.error(`Error fetching project ${collab.project_id}:`, projectError);
        continue;
      }
      
      projects.push({
        ...project,
        role: collab.role
      });
    }
    
    return projects;
  } catch (error) {
    console.error('Error fetching collaborative projects:', error);
    return [];
  }
};
